
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Sjan & Raisoni Achievers Award  </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title mt-3">
                    <h4>Sjan & Raisoni Achievers Award </h4>
                </div>
                <div class="fide-chess-text">
                    <p>Since last five years GHR Sports and Cultural foundation organizing achievement in sports awards in association with SJAN. This association is encouraging the sports person to perform in their fields and personal life.</p>
                    <p> Directly or indirectly we all are associated to the sports in various roles.</p>
                </div>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-5.webp"
                        alt="GHRSCF" />

                </div>
            </div>
        </div>
        <div class="row  row-cols-1 row-cols-lg-3 mt-5">
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">SJAN & Raisoni Achievers Award 2024<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/sjan-award-2024" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col">
                <div class="feature-area">
                    <div class="feature-wrap">
                        <div class="single-feature">
                            <div class="title text-center">
                                <h3 class="fs-4 lh-base">SJAN & Raisoni Achievers Award 2018<i class="fa fa-arrow-right blink"
                                        aria-hidden="true"></i></h3>
                            </div>
                            <a routerLink="/sjan-award" class="cmn-button">
                                Read More
                            </a>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
